export default __webpack_public_path__ + "static/media/1070.7b514796.png";